// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"25af610a","423":"9b9b79cb","511":"8208c491","612":"f11d402d","616":"df2658a8","923":"6eb4cf76","963":"d617ed5b"}[chunkId] + ".chunk.js";
};